import { defineMessages } from 'react-intl';

export default defineMessages({
    nextDescription: {
        id: 'ml.reinstatement.common.views.reinstatement-policy.We reinstate the policy next',
        defaultMessage: 'We\'ll <strong>reinstate the policy</strong> next'
    },
    effectiveDate: {
        id: 'ml.reinstatement.common.views.reinstatement-policy.Effective Date',
        defaultMessage: 'Effective Date'
    },
    reason: {
        id: 'ml.reinstatement.common.views.reinstatement-policy.Reason',
        defaultMessage: 'Reason for Reinstatement'
    },
    bind: {
        id: 'ml.reinstatement.common.config.Reinstating policy...',
        defaultMessage: 'Reinstating policy...'
    },
    bindErrorTitle: {
        id: 'ml.reinstatement.common.config.Unable to bind reinstatement',
        defaultMessage: 'Unable to bind reinstatement'
    },
    bindErrorMsg: {
        id: 'ml.reinstatement.common.config.An error occurred while attempting to bind the reinstatement',
        defaultMessage: 'An error occurred while attempting to bind the reinstatement'
    },
});